import { GeneralService } from './../services/general.service';
import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-triptiva',
  templateUrl: './triptiva.component.html',
  styleUrls: ['./triptiva.component.css']
})
export class TriptivaComponent implements OnInit {

  
  constructor(private commonScriptComponent:CommonScriptComponent, private generalService:GeneralService) { }
  base_url = this.generalService.BASE_URL;
  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/triptiva/triptiva.component.ts